// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function unit(param) {
  
}

var context = React.createContext({
      logo: "Camel",
      theme: "Light",
      language: "English",
      translate: (function (param) {
          return "";
        }),
      setLogo: unit,
      setTheme: unit,
      setLanguage: unit
    });

var make = context.Provider;

var Provider = {
  make: make
};

export {
  unit ,
  context ,
  Provider ,
}
/* context Not a pure module */
